import { documentTemplates, gamersTemplates } from '../../../_layout/js/constants_by.js';
import { ajaxUrl, documentsContainer, gamersContainer } from '../../../_layout/js/constants.js';

import handleAdmonParams from '../../../_layout/js/handleAdmonParams.js';
import setDataLink from '../../../_layout/js/setDataLink.js';
import setAppLink from '../../../_layout/js/setAppLink.js';
import setAppsListLink from '../../../_layout/js/setAppsListLink.js';
import tabs from '../../../_layout/js/tabs.js';
const $documentsContainer = $(documentsContainer);
const $gamersContainer = $(gamersContainer);

$(document).ready(function() {
    setAppLink();

    $.ajax({
        url: ajaxUrl,
        method: 'GET',
        dataType: 'json', 
        success: function(responseData) {
            if (!responseData?.systemSettings) {
                console.error('Отсутствует systemSettings');
                return null;
            }

            setDataLink(responseData.systemSettings, documentTemplates, $documentsContainer, { position: 'prepend' });
            setDataLink(responseData.systemSettings, gamersTemplates, $gamersContainer, { position: 'after', afterIndex: 0 });
            setAppsListLink(responseData.systemSettings);
        },
        error: function(error) {
            console.error('Ошибка запроса:', error);
        }
    });

    tabs();
    handleAdmonParams();
});

var currentQuery = window.location.search;
function appendQueryParams(href) {
    if (!currentQuery || currentQuery === '?') {
        return href;
    }

    const separator = href.includes('?')
        ? '&'
        : '?';
    return href + separator + currentQuery.slice(1);
}

function throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function() {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}

var onclickDesktop = function (e) {
    e.preventDefault();
    window.open(appendQueryParams('https://' + 'win' + 'line.by/' + this.hash.substr(1)), '_top');
};

var isMobile = function() {
    const ua = navigator.userAgent.toLowerCase();
    let res = /\ Mobile\;|\ Mobile\ |OnePlus|MI-ONEPlus|A300|Pixel\ 2|HUAWEIBKL|Huawei\ BKL|Lenovo\ A|Lenovo\ TB|ONE\ TOUCH|ZTE\ BLADE|ZTE\ T|ZTE\ V|ZTE\ G|HONORPLK|PLK-TL|PLK-UL|PLK-L|PLK-AL|VNS-L21|P70-A|SM-A|SM-G|SM-J|SM-N|Tapatalk|PDA|PPC|SAGEM|mmp|pocket|psp|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|wap|nokia|Lumia|Series40|Series60|S60|Meizu.*MX|Meizu.*note|U10|U20|SonyEricsson|Xperia|D5503|N900|\ MI\ |MAUI.*WAP.*Browser|LG-H|LG-K|LG-D|LG-P|LGMS|iPhone|iPod|iTunes|BlackBerry|\bBB10\b|rim[0-9]+|HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6425|001HT|Inspire\ 4G|Android.*\bEVO\b|Nexus\ One|Nexus\ S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus\ 5|Nexus\ 6|Dell.*Streak|Dell.*Aero|Dell.*Venue|DELL.*Venue\ Pro|Dell\ Flash|Dell\ Smoke|Dell\ Mini\ 3iX|XCD28|XCD35|\b001DL\b|\b101DL\b|\bGS01\b|sony|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|Asus.*Galaxy|ASUS_Z|PalmSource|Palm|Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature|IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250|\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\b|PANTECH|IM-A|VEGA\ PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790|Samsung|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E|GT-I|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-P6810|GT-P7100|GT-S|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R4|SCH-T300|SCH-U|SCS-26UC|SGH-A|SGH-B|SGH-C|SGH-D307|SGH-D|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N|SGH-N7|SGH-P|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T|SGH-U|SGH-V|SGH-X|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N8010|Motorola|\bDroid\b.*Build|DROIDX|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT3|XT502|XT530|XT531|XT532|XT535|XT6|XT7|XT8|XT9|Redmi|Ixion/i.test(ua);
    
    //let res = window.matchMedia('(max-width: 707px)').matches;
    return res;
};

var initLinks = function() {
    Array
        .from(document.querySelectorAll('[data-link]'))
        .forEach(function (dom) {
            if (dom.dataset['prevHref']) { 
                dom.href = dom.dataset['prevHref'];
                if (dom.dataset['prevTarget']) {
                    dom.setAttribute('target', dom.dataset['prevTarget']);
                }

                dom.removeEventListener('click', onclickDesktop);
            }

            if (dom.href && !dom.dataset['prevHref']) {
                dom.dataset['prevHref'] = dom.getAttribute('href');
                dom.dataset['prevTarget'] = dom.getAttribute('target');
            }

            var url = dom.hash.substr(1);
            if (isMobile()) {
                url = dom.dataset['mobile'] || url;
                dom.href = appendQueryParams('https://' + 'win' + 'line.by/mobile/' +  (dom.dataset['hrefM'] || url));
                dom.setAttribute('target', '_top');
            } else {
                dom.addEventListener('click', onclickDesktop);
            }
        });
};

document.addEventListener('DOMContentLoaded', initLinks);
window.addEventListener('updateLinks', initLinks);

var isMobilePrev = isMobile();
['load', 'resize', 'orientationchange'].forEach(function(eventName) {
    window.addEventListener(eventName, throttle(function() {
        if (isMobilePrev !== isMobile()) {
            isMobilePrev = isMobile();
            window.dispatchEvent(new Event('updateLinks'));
        }
    }, 250));
});



// WEBPACK FOOTER //
// ./p/program-loyalty-2/src/entry-point.js